<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <sidebar></sidebar>

    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <div class="users-page">

          <a-row>
            <a-col :span="24">
              <h1 class="h2">Site users</h1>
            </a-col>
          </a-row>

          <div>
            <div></div>
            <div class="ant-row-flex ant-row-flex-start licenses-left-filter" style="float: right; margin-bottom: 10px;">
              <div class="mr-8">
                <a-form layout="inline">
                  <a-form-item>
                    <a-input-search placeholder="Search by email" @search="onSearch" :default-value="search" />
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>

          <br>

          <div
              :class="{'ant-spin-nested-loading': true, 'ant-table-with-pagination': loading, 'ant-table-spin-holder': loading}"
          >
            <div v-if="loading">
              <a-spin size="large" />
            </div>
            <div :class="{'ant-spin-container': true, 'ant-spin-blur': loading}">
              <template v-if="users.length > 0">
                <div class="ant-table wemail-table-default users-table">
                  <table>
                    <thead class="ant-table-thead">
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Sites</th>
                      <th>Registered</th>
                      <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody class="ant-table-tbody">
                    <tr class="ant-table-row" v-for="user in users" :key="user.id">
                      <td>{{ user.id }}</td>
                      <td>
                        <router-link
                            :to="{ name: 'site-user', params: {userId: user.id} }"
                        >{{ user.name }}</router-link>
                      </td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.siteCount }}</td>
                      <td>{{ user.created_at }}</td>
                      <td>
                        <a-dropdown placement="topCenter">
                          <a-button type="link" icon="more"> </a-button>
                          <a-menu slot="overlay">
                            <a-menu-item key="delete_user">
                              <a-button @click="deleteConfirm(user)" block type="danger">Delete</a-button>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <pagination :meta="meta" @change="pageChange" label="users"></pagination>
              </template>

              <div v-else class="pt-30">
                <no-items-found>
                  <template slot="icon">
                    <a-icon type="exclamation-circle" />
                  </template>
                  <template slot="title">No users found.</template>
                </no-items-found>
              </div>
            </div>
            <!-- /.ant-spin-container -->
          </div>

          <a-modal
              centered
              :title="`Are you sure to delete ${user.full_name}?`"
              :footer="null"
              :visible="delete_modal"
              @cancel="delete_modal = false"
          >
            <p>This action will delete all the information of <b>{{ user.first_name }}</b> and it's irreversible.</p>
            <p>
              Type <b>DELETE</b> to confirm the deletion of this user. <br/>
              <a-input v-model="delete_confirm_text" style="margin-top: 5px"/>
            </p>
            <p>
              <a-alert
                  message="If you have any additional uses for any of your sites, you will be charged for that during this process. This action may take some time to complete."
                  type="info"
              />
            </p>
            <p style="text-align: right">
              <a-button @click="delete_modal = false">Cancel</a-button>
              <a-button @click.prevent="deleteUser(user.id)" :disabled="delete_confirm_text !== 'DELETE'" :loading="delete_loading" type="danger" style="margin-left: 5px">Delete</a-button>
            </p>
          </a-modal>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import NoItemsFound from "@/components/NoItemsFound.vue";
import Api from "@/services/Api";
import Pagination from "@/components/Pagination.vue";
export default {
  mixins: [],

  components: {
    Sidebar, NoItemsFound, Pagination
  },

  data() {
    return {
      loading: false,
      meta: {},
      users: [],
      user: {},
      delete_modal: false,
      delete_loading: false,
      delete_confirm_text: '',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      userType: '',
    };
  },

  created() {
    this.fetchUsers();
  },

  watch: {
    /**
     * Search query re-rander
     */
    "$route"() {
      this.fetchUsers();
    }
  },


  computed: {
    search() {
      return this.$route.query.search ? this.$route.query.search : "";
    },
    page() {
      return this.$route.query.page ? this.$route.query.page : "";
    }
  },


  methods: {

    /**
     * Fetch All Users
     */
    fetchUsers() {
      this.loading = true;
      Api.get(`wemail/site-users?page=${this.page}&search=${this.search}`)
          .then(response => {
            this.users = response.data.data;
            this.meta = response.data.meta;
          })
          .finally(() => { this.loading = false; });
    },

    impersonate(user) {
      localStorage.setItem( "back_to_token", localStorage.getItem('token') );
      localStorage.setItem( "back_to_user", localStorage.getItem('user') );

      let userData = JSON.stringify({
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        uuid: user.uuid,
      });

      localStorage.setItem( "user", userData );
      localStorage.setItem( "token", user.api_token );

      window.open(window.location.origin);
    },

    copyLoginLink(user) {
      this.$http
          .get(this.$api(`/v1/admin/users/${user.id}/login_key`))
          .then(response => {
            const el = document.createElement("textarea");
            el.value = `${location.origin}/login-using-key/${response.data.login_key}`;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$message.success("Link copied successfully!");
          })
          .finally(() => { this.loading = false; });
    },

    pageChange(current) {
      let route = { ...this.$route.query };

      route.page = current;

      if (this.search) {
        route.search = this.search;
      }

      const newRoute = {
        path: this.$route.path,
        query: route
      };

      this.$router.push(newRoute);
  },

    /**
     * Search Licenses
     */
    onSearch(value) {
      this.$router.push({
        name: 'site-users',
        query: {
          page: this.page,
          search: String(value).trim()
        }
      });
    }, // onSearch

    deleteConfirm(user) {
      this.delete_confirm_text = '';
      this.user = user;
      this.delete_modal = true;
    },

    deleteUser(id) {
      this.delete_loading = true;
      Api.delete(`wemail/site-users/`+ id).then(
          () => {
            this.$notification.success({message: 'User deleted successfully.'});
            this.fetchUsers();
            this.delete_modal = false;
          }).finally(() => this.delete_loading = false );
    },

  }, // methods
};
</script>
<style scoped>

.align-right {
  text-align: right;
}
.wemail-table-default.ant-table {
  margin-bottom: 30px;
}
.wemail-table-default.ant-table table {
  background-color: #fff;
  border-collapse: separate;
}
</style>
